import React from "react";
import BasicModal from "../../../../core/BaseComponents/Modal";
import deleteImg from '../../../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";

function CustomizeWelcomeVideoDelete(props) {

  return (
    <BasicModal
      popupOpen={props?.showDeleteVideoPopUp}
      bodyMessage={<>
        <img src={deleteImg} alt="approve" className="w-40px" />
        <div className="delete-hotel mb-3">{props?.isWelcomeVideoDeletedRef.current?.isWelcomeVideoDeletedModalData ?
          <div className="confirm-delete-hotel">
            <p>Do you really want to Delete Customize Welcome Screen Video ?</p>
          </div> :
          props?.isWelcomeVideoDeletedRef.current?.userConformationVideoModalData?.successMessage}</div>
      </>
      }
      footer={
        props?.isWelcomeVideoDeletedRef.current?.isWelcomeVideoDeletedModalData ?
          {
            primaryButton: {
              buttonName: "Cancel",
              action: props?.popupCloseHandler
            }
            ,
            secondaryButton: {
              buttonName: "Delete",
              action: props?.deleteWelcomeScreenVideoHandler
            }
          } : {
            secondaryButton: {
              buttonName: "OK",
              action: props?.popupCloseHandler
            }
          }
      }
    />
  );
}

export default CustomizeWelcomeVideoDelete;
